import { jsonClass, jsonProperty } from '@sumbricht/json-class-serializer'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'
import { ChatMessageAttachment } from '../chat/chat-message.js'

export class AuditTrailEntryAttachmentData {
	@jsonProperty(ArrayBuffer)
	readonly content: ArrayBuffer
	@jsonProperty()
	readonly mimeType?: string

	constructor(init: AuditTrailEntryAttachmentData) {
		assignCommonProperties(this, init)
	}
}

@jsonClass('AuditTrailEntryAttachment')
export class AuditTrailEntryAttachment
	extends AuditTrailEntryAttachmentData
	implements ChatMessageAttachment
{
	@jsonProperty()
	id: number
	@jsonProperty()
	entryId: number
	@jsonProperty()
	previewImage: ArrayBuffer | null

	constructor(init: AuditTrailEntryAttachment) {
		super(init)
		assignCommonProperties(this, init)
	}
}
